import * as types from "../../constants";
import {
  fetchA11yes as a11yFetchA11yes,
  createA11y as a11yCreateA11y,
  deleteA11y as a11yDeleteA11y,
  updateA11y as a11yUpdateA11y,
  partialUpdateA11y as a11yPartialUpdateA11y, fetchA11yesQuery
} from "../../services/a11yesService";
import { A11yActions } from "../reducers/a11yesReducer";
import { DispatchOf } from "../utils";
import { getCountsDisabilityTypes } from "../../utils/functions";
import {ErrorsActions} from "../reducers/toastsReducer";

export function fetchA11yes(a11yUnitId: any, token: any) {
    return async (dispatch: DispatchOf<A11yActions> & DispatchOf<ErrorsActions>) => {
        return a11yFetchA11yes(a11yUnitId, token)
            .then((response) => {
                dispatch({
                    type: "FETCH_A11YES",
                    payload: response.results
                });
            }).catch((error) => {
                dispatch({
                    type: types.ADD_TOAST,
                    payload: error
                })
          })
    };
}

export function clearA11yes() {
    return ({
        type: types.CLEAR_A11YES,
        payload: {}
    })
}

export function createA11y(data: any, token: any) {
    return async (dispatch: DispatchOf<A11yActions> & DispatchOf<ErrorsActions>) => {
        return a11yCreateA11y(data, token)
            .then((response) => {
                dispatch({
                    type: types.CREATE_A11Y,
                    payload: response
                });
            }).catch((error) => {
                dispatch({
                  type: types.ADD_TOAST,
                  payload: error
                })
          })
    };
}
export function deleteCreateA11y(id: any, token: any, index: any, a11yData: any) {
    return async (dispatch: DispatchOf<A11yActions> & DispatchOf<ErrorsActions>) => {
        return a11yDeleteA11y(id, token)
            .then(() => {
                dispatch({
                    type: types.DELETE_A11Y,
                    payload: index
                })
                dispatch(createA11y(a11yData, token))
            }).catch((error) => {
                dispatch({
                    type: types.ADD_TOAST,
                    payload: error
                })
          })
    };
}
export function deleteA11y(id: any, token: any, index: any) {
    return async (dispatch: DispatchOf<A11yActions> & DispatchOf<ErrorsActions>) => {
        return a11yDeleteA11y(id, token)
            .then(() => {
                dispatch({
                    type: types.DELETE_A11Y,
                    payload: index
                });
            }).catch((error) => {
                dispatch({
                    type: types.ADD_TOAST,
                    payload: error
                })
          })
    };
}

export function updateA11y(index: any, id: any, data: any, token: any) {
    return async (dispatch: DispatchOf<A11yActions> & DispatchOf<ErrorsActions>) => {
        return a11yUpdateA11y(id, data, token)
            .then((response) => {
                dispatch({
                    type: types.UPDATE_A11Y,
                    payload: { response, index },
                });
            }).catch((error) => {
                dispatch({
                    type: types.ADD_TOAST,
                    payload: error
                })
          })
    };
}

export function partialUpdateA11y(index: any, id: any, data: any, token: any) {
    return async (dispatch: DispatchOf<A11yActions> & DispatchOf<ErrorsActions>) => {
        return a11yPartialUpdateA11y(id, data, token)
            .then((response) => {
                dispatch({
                    type: types.UPDATE_A11Y,
                    payload: { response, index },
                });
            }).catch((error) => {
                dispatch({
                    type: types.ADD_TOAST,
                    payload: error
                })
          })
    };
}

export function fetchCountsDisabilityTypes(token: any, companyId?: string) {
  let query: any = {fields: 'disability_types', limit: 100000}
  if (companyId) query.accessibility_unit__property__company = companyId
  return async (dispatch: DispatchOf<A11yActions> & DispatchOf<ErrorsActions>) => {
    return fetchA11yesQuery(query, token)
      .then((response) => {
        dispatch({
          type: types.FETCH_COUNTS_DISABILITY_TYPES,
          payload: getCountsDisabilityTypes(response.results)
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function clearCountsDisabilityTypes() {
  return ({
    type: types.CLEAR_COUNTS_DISABILITY_TYPES
  })
}


export function fetchA11yesByProperty(token: any, propertyId: string) {
  return async (dispatch: DispatchOf<A11yActions> & DispatchOf<ErrorsActions>) => {
    return fetchA11yesQuery({accessibility_unit__property__id: propertyId, limit: 999}, token)
      .then((response) => {
        dispatch({
          type: types.FETCH_A11YES_BY_PROPERTY,
          payload: response.results
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function clearA11yesByProperty() {
  return ({
    type: types.CLEAR_A11YES_BY_PROPERTY
  })
}

